import {Component} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import PaginationFilter from "../../components/PaginationFilter";
import {notFound} from "../../components/notFound";

class KarAfarin extends Component {
    static contextType = simplyContext

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const pageValue = searchParams.get('page');
        this.context.fNoavar({
            'pageNumber': pageValue,
        })
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
        if (this.props.location.key !== prevProps.location.key) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const pageValue = searchParams.get('page');
            this.context.fNoavar({
                'pageNumber': pageValue,
            })
        }
    }


    render() {
        return (
            <HelmetProvider>
                <Helmet>
                    <title>نوآور و کارآفرین</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/نوآور-و-کارآفرین"}/>
                </Helmet>

                {this.context.state.sKotobMarjaitElmi !== null ? (
                    <div className='container-fluid cFlex1'>

                        {header(this.context)}


                        <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 lh-lg'>
                                        <NavLink to={urlDynamic.path.homeFa}
                                                 className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                            اصلی</NavLink>
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <h1 className='cColor2 d-inline-block cFontSize13'>نوآور و کارآفرین</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.context.state.sKotobMarjaitElmi.notFound === true ? (
                            notFound()
                        ) : (
                            <div className='row pt-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                                <div className='cContainer col-12'>
                                    <div className='row cBg4 justify-content-center'>
                                        <div className='col-12'>
                                            <div className='row'>
                                                {this.context.state.sKotobMarjaitElmi.kotob.map((p, index) => (
                                                    <div key={index} className='col-12 col-sm-6 col-lg-3 my-3'>
                                                        <div>
                                        <NavLink target={"_blank"} to={p.urlPdf} key={index}
                                                 className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4 border">
                                            <img src={p.urlImage} width="515" height='646' className="img-fluid"
                                                 alt="تصویر"/>
                                        </NavLink>
                                </div>
                                                    </div>
                                                ))}
                                                <div className='col-12 mb-5'>
                                                    <PaginationFilter func={this.context.fDropDown}
                                                                      state={this.context.state.sKotobMarjaitElmi}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {footer()}


                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(KarAfarin)